import classNames from 'classnames';
import PropTypes from 'prop-types';

import { ErrorText } from '@utilities';

import { CHAT_MESSAGE_LENGTH_ERROR } from '../../utilities/constants';

import styles from './_index.module.scss';

export const NARRATIVES_CHAT_INPUT_ERROR_ID = 'narratives-chat-input-error';

const NarrativesChatInputFooter = ({ capacityTracker, centered, isInputTooLong }) => {
  if (isInputTooLong) {
    return (
      <ErrorText
        className={classNames(styles['chat-input-error'], {
          [styles['chat-input-error-centered']]: centered,
          [styles['chat-input-error-default']]: !centered,
        })}
        id={NARRATIVES_CHAT_INPUT_ERROR_ID}
        role="status"
        text={CHAT_MESSAGE_LENGTH_ERROR}
      />
    );
  }

  if (!capacityTracker) return null;

  return centered ? (
    <div className={styles['chat-capacity-tracker']}>{capacityTracker}</div>
  ) : (
    capacityTracker
  );
};

NarrativesChatInputFooter.propTypes = {
  capacityTracker: PropTypes.node,
  centered: PropTypes.bool,
  isInputTooLong: PropTypes.bool.isRequired,
};

NarrativesChatInputFooter.defaultProps = {
  capacityTracker: null,
  centered: false,
};

export default NarrativesChatInputFooter;
